import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M10.3316 8.36777C9.20158 3.57777 7.41158 0.747732 4.78158 1.01773C1.38158 1.35773 -0.888422 9.13777 3.17158 19.0578C5.23158 24.0978 7.71158 24.9577 9.44158 24.0177C11.1716 23.0777 12.6216 18.0478 10.3316 8.36777Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.7717 13.2779C3.7717 13.2779 2.5317 7.24789 4.2517 5.63789C5.9617 4.03789 8.8717 7.8579 8.7917 18.5179"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M3.7715 13.2778C3.2415 11.4078 2.8615 9.47788 3.0615 7.44788C3.1415 6.93788 3.2215 6.41785 3.5015 5.91785C3.7615 5.43785 4.2115 4.89787 4.9515 4.81787C5.1215 4.82787 5.31149 4.81785 5.47149 4.85785C5.62149 4.91785 5.7715 4.97784 5.9215 5.03784C6.1615 5.20784 6.4215 5.37784 6.5815 5.59784C6.7815 5.79784 6.94149 6.01785 7.0715 6.23785C7.23149 6.45785 7.3415 6.68785 7.4615 6.91785C8.3515 8.76785 8.67149 10.7379 8.8615 12.6779C9.04149 14.6279 8.98149 16.5778 8.7815 18.5178C8.5915 16.5878 8.3815 14.6678 8.0815 12.7778C7.9115 11.8378 7.7615 10.8979 7.5015 9.98785C7.2715 9.06785 6.9815 8.17786 6.5715 7.36786C6.4715 7.15786 6.3715 6.95783 6.2515 6.77783C6.1415 6.58783 6.0115 6.40782 5.8715 6.26782C5.6015 5.95782 5.27149 5.73787 5.02149 5.75787C4.76149 5.74787 4.46149 5.99783 4.27149 6.33783C4.05149 6.66783 3.9515 7.12786 3.8415 7.55786C3.5215 9.38786 3.6115 11.3478 3.7715 13.2778Z"
        fill={outline}
      />
      <path
        d="M71.6517 8.36777C72.7817 3.57777 74.5717 0.747732 77.2017 1.01773C80.6017 1.35773 82.8717 9.13777 78.8117 19.0578C76.7517 24.0978 74.2717 24.9577 72.5417 24.0177C70.8217 23.0777 69.3617 18.0478 71.6517 8.36777Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M78.2213 13.2778C78.2213 13.2778 79.4613 7.24777 77.7413 5.63777C76.0313 4.03777 73.1213 7.85777 73.2013 18.5178"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M78.2216 13.2778C78.3816 11.3578 78.4716 9.39776 78.1616 7.57776C78.0516 7.13776 77.9416 6.68779 77.7316 6.35779C77.5316 6.01779 77.2316 5.76777 76.9816 5.77777C76.7316 5.75777 76.4016 5.96778 76.1316 6.28778C75.9916 6.43778 75.8616 6.60779 75.7516 6.79779C75.6216 6.97779 75.5216 7.17776 75.4316 7.38776C75.0216 8.19776 74.7216 9.09781 74.5016 10.0078C74.2416 10.9178 74.0816 11.8578 73.9216 12.7978C73.6216 14.6878 73.4216 16.5978 73.2216 18.5378C73.0216 16.6078 72.9716 14.6478 73.1416 12.6978C73.3316 10.7478 73.6516 8.78781 74.5416 6.93781C74.6516 6.70781 74.7716 6.47781 74.9316 6.25781C75.0716 6.03781 75.2316 5.8178 75.4216 5.6178C75.5816 5.4078 75.8516 5.2378 76.0816 5.0578C76.2316 4.9878 76.3816 4.92781 76.5316 4.87781C76.6916 4.83781 76.8816 4.83777 77.0516 4.83777C77.7916 4.90777 78.2416 5.44781 78.5016 5.93781C78.7816 6.43781 78.8516 6.95777 78.9416 7.46777C79.1216 9.46777 78.7516 11.4078 78.2216 13.2778Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.6311 10.7093) rotate(163.758) scale(5.07606 7.41653)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(74.3439 10.5846) rotate(16.2421) scale(5.07606 7.41653)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
